var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusCircleOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#FFF3DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.75C28 22.8516 23.0586 27.75 17 27.75C10.8984 27.75 6 22.8516 6 16.75C6 10.6914 10.8984 5.75 17 5.75C23.0586 5.75 28 10.6914 28 16.75ZM17 7.8125C12.0586 7.8125 8.0625 11.8516 8.0625 16.75C8.0625 21.6914 12.0586 25.6875 17 25.6875C21.8984 25.6875 25.9375 21.6914 25.9375 16.75C25.9375 11.8516 21.8984 7.8125 17 7.8125Z",
    fill: "#F0B13D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCircleOpen);
export default __webpack_public_path__ + "static/media/status-circle-open.d2e3e24c682143e81635ff08a5cd064a.svg";
export { ForwardRef as ReactComponent };